import { render, staticRenderFns } from "./Polygon.vue?vue&type=template&id=6113db7d&scoped=true"
import script from "./Polygon.vue?vue&type=script&lang=js"
export * from "./Polygon.vue?vue&type=script&lang=js"
import style0 from "./Polygon.vue?vue&type=style&index=0&id=6113db7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6113db7d",
  null
  
)

export default component.exports